import { render, staticRenderFns } from "./FlashCardAdmin.vue?vue&type=template&id=488fe661&scoped=true&"
import script from "./FlashCardAdmin.vue?vue&type=script&lang=js&"
export * from "./FlashCardAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardAdmin.vue?vue&type=style&index=0&id=488fe661&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fe661",
  null
  
)

export default component.exports